'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import {bp} from '../../../_scripts/_helper';

export default class SiteHeader {
  constructor() {

    /* Mobile Menu */
    let $menuWrapper = $('.menu-wrapper'),
        $mobileMenuIconContainer = $('.mobile-menu-icon-container'),
        $mobileMenuIcon = $('.mobile-menu-icon'),
        $searchBtn = $('.js-search-menu'),
        $mSearchBar = $('.m-search-bar');

    let $mobileMenu = function(event) {
      event.stopPropagation();

      // remove the search if it is open
      if($searchBtn.hasClass('is-active')) {
        $searchBtn.removeClass('is-active');
        $mSearchBar.removeClass('search-open');
      }

      if($(this).hasClass('open')) {
          $menuWrapper.slideUp(150);
      } else {
         $menuWrapper.slideDown(150);
      }
      $(this).toggleClass('open');
      $mobileMenuIconContainer.toggleClass('is-active');
      // if($(this).hasClass('open')) {

      // }
    };
    $mobileMenuIcon.on('click', $mobileMenu);

    // Reset Mobile Menu for desktop
    enquire.register("screen and (min-width:"+bp.minDesktop+"px)", {
      match : function() {
        $mobileMenuIcon.removeClass('open');
        $menuWrapper.css('display', '');
      }
    });


    /* =========================================================
    >> Font resizer
    ============================================================ */
    let $fontResizer = $('.js-resizer');
    //change font size
    $fontResizer.on('click', function(e) {
      e.preventDefault();
      let size = $(this).data('size');

      $fontResizer.removeClass('is-active');
      $(this).addClass('is-active');

      if (size == 'normal') {
        $('#mainContent').removeClass('font-large').removeClass('font-larger').addClass('font-normal');
      } else if (size == 'big') {
        $('#mainContent').removeClass('font-larger').removeClass('font-normal').addClass('font-large');
      } else if (size == 'bigger') {
        $('#mainContent').removeClass('font-normal').removeClass('font-large').addClass('font-larger');
      }

      // reset matchheight elements after font resize
      setTimeout(function() {
        $('.home-events__item').matchHeight();
      }, 350);

    });



    /* =========================================================
    >> Mobile Search
    ============================================================ */
    $searchBtn.on('click', function(e) {
      e.preventDefault();

      // close the menu if it is open
      if ($mobileMenuIcon.hasClass('open')) {
        $mobileMenuIcon.trigger('click');
      }

      $(this).toggleClass('is-active');
      $mSearchBar.toggleClass('search-open');
      $mSearchBar.find('.mobileSearch').focus();

      // Close search by clicking anywhere of the document
      $(document).on('click.closeSearchMenu', function (e) {
        if (!$(e.target).closest('.m-search-bar').length && !$(e.target).closest('.js-search-menu').length) {
          $searchBtn.removeClass('is-active');
          $mSearchBar.removeClass('search-open');
        }
      });
    });

    
// Search Bar toggle

$('#showSearch').on('click', function (e) {
  e.preventDefault();
  $('#toggleIcon').toggleClass('icon-search');
  $('#toggleIcon').toggleClass('icon-close');
  $('.search_bar').slideToggle();
});


  }
}
